"use client";
import { jsxs as p, Fragment as b, jsx as e } from "react/jsx-runtime";
import { cn as l } from "../../../utils/cn.js";
import h from "next/link";
import { memo as x } from "react";
import '../../../assets/PlateImage.css';const y = "_plate_18cvn_1", N = "_bottom_18cvn_45", f = "_top_18cvn_48", w = "_text_18cvn_52", j = "_white_18cvn_56", u = "_violet_18cvn_61", I = "_orange_18cvn_66", L = "_gray_18cvn_71", P = "_red_18cvn_76", k = "_notice_18cvn_81", t = {
  plate: y,
  bottom: N,
  top: f,
  text: w,
  white: j,
  violet: u,
  orange: I,
  gray: L,
  red: P,
  notice: k
}, F = x(
  ({
    text: v,
    color: c,
    className: g,
    href: s,
    onClick: o,
    placeText: n = "bottom",
    children: _,
    ...a
  }) => {
    const r = (d) => {
      o == null || o(
        d
      );
    }, i = l(t.plate, t[n], g), m = /* @__PURE__ */ p(b, { children: [
      n === "bottom" && _,
      /* @__PURE__ */ e(
        "div",
        {
          className: l(t.text, {
            [t.orange]: c === "orange",
            [t.violet]: c === "violet"
          }),
          children: v
        }
      ),
      n === "top" && _
    ] });
    return s ? /* @__PURE__ */ e(h, { href: s, onClick: r, className: i, ...a, children: m }) : /* @__PURE__ */ e("button", { onClick: r, className: i, ...a, children: m });
  }
);
F.displayName = "PlateImage";
export {
  F as PlateImage
};
